<div id="app-sharemailbox-add-dialog">
  <div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-primary">
      <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
        <span class="title dialog-title">
          {{ 'SHAREDMAILBOX-ADD-FORM.TITLE' | translate }}</span
        >
        <button
          mat-icon-button
          (click)="matDialogRef.close()"
          aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <mat-horizontal-stepper
      class="mat-elevation-z1 mat-stepper-horizontal"
      [linear]="true"
      labelPosition="bottom">
      <mat-step [completed]="addSharemailBoxForm.valid">
        <form fxLayout="column" fxFill [formGroup]="addSharemailBoxForm">
          <h2 class="step-title">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.TITLE' | translate }}
          </h2>
          <div fxLayout="column" fxLayoutAlign="start start">
            <div class="form-text">
              {{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.NAMEINFO' | translate }}
            </div>
            <mat-form-field class="step-input" fxFlex appearance="outline">
              <mat-label
                >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.NAMELABEL' | translate
                }}</mat-label
              >
              <input
                autocomplete="on"
                matInput
                formControlName="sharemailboxName"
                required />
              @if
              (addSharemailBoxForm.get('sharemailboxName').hasError('pattern'))
              {
              <mat-error
                >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.NAMEPATTERNERROR' | translate
                }}</mat-error
              >
              } @if
              (addSharemailBoxForm.get('sharemailboxName').hasError('required'))
              {
              <mat-error
                >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.NAMEREQUIREDERROR' | translate
                }}</mat-error
              >
              }@if
              (addSharemailBoxForm.get('sharemailboxName').hasError('maxlength'))
              {
              <mat-error
                >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.NAMEMAXLENGTHERROR' |
                translate }}</mat-error
              >
              }
            </mat-form-field>
            <div
              fxLayout="column"
              class="mr-16 text-container"
              fxLayoutAlign="start start">
              <h3>
                {{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.PROVISIONALNAMESTITLE' |
                translate }}
              </h3>
              <div>
                {{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.PROVISIONALNAMESINFO' |
                translate }}
              </div>
            </div>
            <div fxLayout="column" class="name-input-container">
              <mat-form-field
                class="step-input name-input"
                fxFlex="50"
                fxFlex
                appearance="outline">
                <mat-label
                  >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.DISPLAYNAME' | translate
                  }}</mat-label
                ><input matInput [value]="createDisplayName()" disabled
              /></mat-form-field>
              <mat-form-field
                class="step-input name-input"
                fxFlex="50"
                fxFlex
                appearance="outline">
                <mat-label
                  >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE1.EMAIL' | translate
                  }}</mat-label
                ><input
                  matInput
                  [value]="createMailAddress() ? createMailAddress() + '@edu.vs.ch': ''"
                  disabled
              /></mat-form-field>
            </div>
          </div>
        </form>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="end center">
          <button
            mat-raised-button
            matStepperNext
            type="button"
            color="accent"
            [disabled]="!addSharemailBoxForm.valid">
            {{ 'GENERAL.NEXT' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <h2 class="step-title">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE2.TITLE' | translate }}
          </h2>
          <div class="form-text">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE2.INFOTEXT1' | translate }}
          </div>
          <div class="form-text">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE2.INFOTEXT2' | translate }}
          </div>
          <h3 class="labels">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE2.ROLESLABEL' | translate }}
          </h3>
        </div>
        <div fxLayout="row" class="checkbox-container">
          <div fxLayout="column" fxFlex="50" class="checkboxes">
            <mat-checkbox class="form-text" [(ngModel)]="ajout_Directeur"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-DIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_ConseilDir"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-CONSDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_secDir"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-SECDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_ITRes"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-RI' | translate
              }}</mat-checkbox
            >
          </div>
          <div fxLayout="column" fxFlex="50" class="checkboxes">
            <mat-checkbox class="form-text" [(ngModel)]="ajout_ITGest"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-GESTIT' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_admin"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-ADMIN' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="ajout_Tech"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-TECH' | translate
              }}</mat-checkbox
            >
          </div>
        </div>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <h3 class="labels">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE2.NOMINATIVELABEL' | translate }}
          </h3>
          <div class="form-text">
            {{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS-DESC' | translate }}
          </div>
        </div>
        <div fxLayout="row" class="checkbox-container">
          <mat-checkbox
            class="form-text"
            [(ngModel)]="ajout_Nominatif"
            (change)="cleanNomivativeList('a')"
            >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE2.NOMINATIVESELECT' | translate
            }}</mat-checkbox
          >
        </div>
        <div fxLayout="row" class="users-container" *ngIf="ajout_Nominatif">
          <div fxLayout="column" fxFlex="90" class="users-selected">
            <mat-form-field
              class="chip-list"
              appearance="fill"
              class="nom-access">
              <mat-label
                >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS' | translate
                }}</mat-label
              >
              <mat-chip-grid
                #gridUserSelection
                aria-label="User selection"
                class="mat-chip-list label-chips">
                <mat-chip-row
                  *ngFor="let user of users_acces"
                  (removed)="removeAccess(user)"
                  class="mat-chip mat-standard-chip label-chip background-selected">
                  {{ user.officialemail }}
                  <button matChipRemove class="removeBtn">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input [matChipInputFor]="gridUserSelection" hidden />
            </mat-form-field>
          </div>
          <div
            class="button-user-selected"
            fxLayout="column"
            fxDirection="end"
            fxFlex="10"
            fxLayoutAlign="center center">
            <button
              mat-raised-button
              type="button"
              color="accent"
              class="add-nom-btn"
              (click)="addUserForAccess()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="space-between center">
          <button
            class="btn-container"
            mat-raised-button
            matStepperPrevious
            type="button"
            color="accent">
            {{ 'GENERAL.PREVIOUS' | translate }}
          </button>
          <button mat-raised-button matStepperNext type="button" color="accent">
            {{ 'GENERAL.NEXT' | translate }}
          </button>
        </div>
      </mat-step>
      <mat-step>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <h2 class="step-title">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE3.TITLE' | translate }}
          </h2>
          <div class="form-text">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE3.INFOTEXT' | translate }}
          </div>
          <div class="form-text" style="font-style: italic">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE3.EXAMPLE' | translate }}
          </div>
          <h3 class="labels">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE3.ROLESLABEL' | translate }}
          </h3>
        </div>
        <div fxLayout="row" class="checkbox-container">
          <div fxLayout="column" fxFlex="50" class="checkboxes">
            <mat-checkbox class="form-text" [(ngModel)]="sendas_Directeur"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-DIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="sendas_ConseilDir"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-CONSDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="sendas_secDir"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-SECDIR' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="sendas_ITRes"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-RI' | translate
              }}</mat-checkbox
            >
          </div>
          <div fxLayout="column" fxFlex="50" class="checkboxes">
            <mat-checkbox class="form-text" [(ngModel)]="sendas_ITGest"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-GESTIT' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="sendas_admin"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-ADMIN' | translate
              }}</mat-checkbox
            >
            <mat-checkbox class="form-text" [(ngModel)]="sendas_Tech"
              >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.GROUP-TECH' | translate
              }}</mat-checkbox
            >
          </div>
        </div>
        <div
          fxLayout="column"
          class="mr-16 text-container"
          fxLayoutAlign="start start">
          <h3 class="labels">
            {{ 'SHAREDMAILBOX-ADD-FORM.PAGE3.NOMINATIVELABEL' | translate }}
          </h3>
          <div class="form-text">
            {{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS-DESC' | translate }}
          </div>
        </div>
        <div fxLayout="row" class="checkbox-container">
          <mat-checkbox
            class="form-text"
            [(ngModel)]="sendas_Nominatif"
            (change)="cleanNomivativeList('s')"
            >{{ 'SHAREDMAILBOX-ADD-FORM.PAGE3.NOMINATIVESELECT' | translate
            }}</mat-checkbox
          >
        </div>
        <div fxLayout="row" class="users-container" *ngIf="sendas_Nominatif">
          <div fxLayout="column" fxFlex="90" class="users-selected">
            <mat-form-field
              class="chip-list"
              appearance="fill"
              class="nom-access">
              <mat-label
                >{{ 'SHAREDMAILBOX-DETAIL-FORM.FORM.NOM-ACCESS' | translate
                }}</mat-label
              >
              <mat-chip-grid
                #gridUserSelection2
                aria-label="User selection"
                class="mat-chip-list label-chips">
                <mat-chip-row
                  *ngFor="let user of user_sendAs_Nom"
                  (removed)="removeSendas(user)"
                  class="mat-chip mat-standard-chip label-chip background-selected">
                  {{ user.officialemail }}
                  <button matChipRemove class="removeBtn">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              </mat-chip-grid>
              <input [matChipInputFor]="gridUserSelection2" hidden />
            </mat-form-field>
          </div>
          <div
            class="button-user-selected"
            fxLayout="column"
            fxDirection="end"
            fxFlex="10"
            fxLayoutAlign="center center">
            <button
              mat-raised-button
              type="button"
              color="accent"
              class="add-nom-btn"
              (click)="addUserForSendAs()">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxFill="100"
          *ngIf="isErrorCreateSharemailbox">
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR2'">
            {{ 'ERROR.2' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR18'">
            {{ 'ERROR.18' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR21'">
            {{ 'ERROR.21' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR30'">
            {{ 'ERROR.30' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR31'">
            {{ 'ERROR.31' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR32'">
            {{ 'ERROR.32' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR40'">
            {{ 'ERROR.40' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === 'ERR403'">
            {{ 'ERROR.402' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === undefined">
            {{ 'ERROR.2' | translate }}
          </div>
          <div
            class="message-box error user-created"
            *ngIf="errorCreateSharemailbox.error.code === null">
            {{ 'ERROR.2' | translate }}
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="column"
          fxLayoutAlign="center center"
          *ngIf="isBusyCreateSharemailbox">
          <div fxFlex="100">
            <mat-progress-spinner
              [color]="spinner.color"
              [mode]="spinner.mode"
              [value]="spinner.value"
              [diameter]="spinner.diameter">
            </mat-progress-spinner>
          </div>
          <br />
          <div fxFlex="100">
            {{ 'SHAREDMAILBOX-ADD-FORM.LOADING' | translate }}
          </div>
        </div>
        <div
          class="success-container"
          fxLayout="column"
          fxFill="100"
          *ngIf="issharemailboxCreated">
          <div class="row">
            <div class="message-box success user-created">
              {{ 'SHAREDMAILBOX-ADD-FORM.SUCCESS' | translate }}
            </div>
          </div>
          <div class="row">
            <button
              mat-raised-button
              matStepperNext
              type="button"
              color="accent"
              class="btn-submit"
              (click)="matDialogRef.close()">
              {{ 'GENERAL.CONFIRMANDLEAVE' | translate }}
            </button>
          </div>
        </div>
        <div
          class="general-container"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          *ngIf="!issharemailboxCreated">
          <button
            class="btn-container"
            mat-raised-button
            matStepperPrevious
            type="button"
            color="accent">
            {{ 'GENERAL.PREVIOUS' | translate }}
          </button>
          <button
            mat-raised-button
            type="button"
            color="accent"
            (click)="createSharemailbox()"
            [disabled]="addSharemailBoxForm.invalid">
            {{ 'GENERAL.SAVE' | translate }}
          </button>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
